module.exports = __webpack_public_path__ + "img/Nyromantikk_Tanker_i_tida1.0f442e5d.jpg";